const PublishOptionsHeaders = {
  MESSAGE_TAG                  : 'message',
  IOS_ALERT_TAG                : 'ios-alert',
  IOS_BADGE_TAG                : 'ios-badge',
  IOS_SOUND_TAG                : 'ios-sound',
  ANDROID_TICKER_TEXT_TAG      : 'android-ticker-text',
  ANDROID_CONTENT_TITLE_TAG    : 'android-content-title',
  ANDROID_CONTENT_TEXT_TAG     : 'android-content-text',
  ANDROID_ACTION_TAG           : 'android-action',
  WP_TYPE_TAG                  : 'wp-type',
  WP_TITLE_TAG                 : 'wp-title',
  WP_TOAST_SUBTITLE_TAG        : 'wp-subtitle',
  WP_TOAST_PARAMETER_TAG       : 'wp-parameter',
  WP_TILE_BACKGROUND_IMAGE     : 'wp-backgroundImage',
  WP_TILE_COUNT                : 'wp-count',
  WP_TILE_BACK_TITLE           : 'wp-backTitle',
  WP_TILE_BACK_BACKGROUND_IMAGE: 'wp-backImage',
  WP_TILE_BACK_CONTENT         : 'wp-backContent',
  WP_RAW_DATA                  : 'wp-raw'
}

export default PublishOptionsHeaders



// WEBPACK FOOTER //
// ./src/messaging/helpers/publish-options-header.js